<!-- 导出弹窗 -->
<template>
  <div>
    <el-dialog
      :title="isPrint ? $t('打印设置') : $t('导出设置')"
      :visible.sync="visibleSync"
      width="580px"
      class="dialog"
      @opened="handleOpenDialog"
      @close="handleClose"
    >
      <div>
        <el-radio-group v-model="exportStyle" v-removeAriaHidden>
          <el-radio :label="1">{{ isPrint ? $t('打印勾选结果') : $t('导出勾选结果') }}</el-radio>
          <el-radio :label="2">{{ isPrint ? $t('打印筛选结果') : $t('导出筛选结果') }}</el-radio>
          <el-radio :label="3">
            {{ isPrint ? $t('打印筛选结果前') : $t('导出筛选结果前') }}
            <el-input
              v-model="exportNum"
              class="input_export"
              type="text"
              :placeholder="filterPlaceholder || $t('请输入数字')"
              :min="1"
              @input="changeInput"
            />
            {{ $t('条') }}
          </el-radio>
        </el-radio-group>
      </div>
      <div
        v-if="showCheckBox"
        style="border: 1px solid #f0f0f0; height: 380px; overflow: auto; padding: 20px 0"
      >
        <div class="title_top pl-2 mb-1">
          <el-checkbox
            v-model="treeChecked"
            :indeterminate="isIndeterminate"
            @change="handletreeCheckedAll"
          />
          <span class="d-inline-block ml-1">{{ isPrint ? $t('选择打印字段') : $t('选择导出字段') }}</span>
        </div>
        <el-tree
          ref="tree"
          :data="treeData"
          show-checkbox
          :node-key="nodeKey"
          :expand-on-click-node="false"
          :default-expand-all="true"
          :check-on-click-node="true"
          :props="defaultProps"
          @check="handleTreeDataCheck"
        />
      </div>
      <span slot="footer">
        <ku-button type="secondary" fill @click="visibleSync = false">
          {{ $t('取 消') }}
        </ku-button>
        <ku-button type="primary" :loading="loading" @click="exportDialogConfirm">
          {{ $t('确 定') }}
        </ku-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ExportPopUp',
  props: {
    isPrint: {
      type: Boolean,
      default: false
    },
    filterPlaceholder: {
      type: String,
      default: ''
    },
    treeData: {
      // 导出字段
      type: Array,
      default() {
        [];
      }
    },
    selectedIds: {
      // 勾选的列表项
      type: Array,
      default() {
        [];
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    showCheckBox: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    // tree是否多级数据
    isMultilevel: {
      type: Boolean,
      default: false
    },
    // tree绑定key
    nodeKey: {
      type: String,
      default: 'name'
    },
    // tree展示label字段
    nodeLabel: {
      type: String,
      default: 'name'
    }
  },
  data() {
    return {
      exportStyle: 1, // 导出类型
      exportNum: '', // 导出数
      isIndeterminate: false, // 全选标识
      treeChecked: false, // 全选未勾选
      defaultProps: {
        children: 'children',
        label: this.nodeLabel
      },
      visibleSync: false
    };
  },
  watch: {
    visible() {
      this.visibleSync = this.visible;
    }
  },
  mounted() {},
  methods: {
    exportDialogConfirm() {
      // 确认导出
      if (this.exportStyle === 1 && this.selectedIds.length === 0) {
        this.$message.info(this.isPrint ? this.$t('请在列表勾选需要打印的数据') : this.$t('请在列表勾选需要导出的数据'));
        return false;
      }
      if (this.exportStyle === 3 && !this.exportNum) {
        this.$message.info(this.isPrint ? this.$t('请输入需要打印的数据数量') : this.$t('请输入需要导出的数据数量'));
        return false;
      }
      if (this.$refs.tree?.getCheckedNodes().length === 0) {
        this.$message.info(this.isPrint ? this.$t('请选择要打印的字段') : this.$t('请选择要导出的字段'));
        return false;
      }
      const checkedNodes = this.$refs.tree?.getCheckedNodes() || []; // 勾选节点
      const halfCheckedNodes = this.$refs.tree?.getHalfCheckedNodes() || []; // 半选中节点
      var objData = {
        title: this.isMultilevel ? [...checkedNodes, ...halfCheckedNodes] : checkedNodes,
        exportStyle: this.exportStyle,
        exportNum: this.exportNum
      };
      this.$emit('getData', objData); // 接收数据
    },
    handleClose() {
      // 关闭
      this.exportNum = '';
      this.exportStyle = 1;
      this.$emit('close', false);
    },
    handleOpenDialog() {
      // 打开导出弹窗
      this.treeChecked = true;
      this.$refs.tree?.setCheckedNodes(this.treeData);
      this.$emit('open');
    },
    handletreeCheckedAll() {
      // 导出全选
      if (this.treeChecked) {
        // 全选
        this.$refs.tree.setCheckedNodes(this.treeData);
      } else {
        // 取消选中
        this.$refs.tree.setCheckedKeys([]);
      }
      this.isIndeterminate = false;
    },
    handleTreeDataCheck(data) {
      // 导出字段勾选
      if (this.isMultilevel) {
        // 多级表头导出
        if (this.$refs.tree?.getCheckedNodes().filter(v => { return v.children && v.children.length; }).length === this.treeData.length) {
          this.isIndeterminate = false;
          this.treeChecked = true;
        } else {
          this.isIndeterminate = true;
          this.treeChecked = false;
        }
      } else {
        // 单级表头导出
        if (this.$refs.tree?.getCheckedNodes().length === this.treeData.length) {
          this.isIndeterminate = false;
          this.treeChecked = true;
        } else {
          this.isIndeterminate = true;
          this.treeChecked = false;
        }
      }
      if (this.$refs.tree?.getCheckedNodes().length === 0) {
        this.treeChecked = false;
        this.isIndeterminate = false;
      }
    },
    changeInput() {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时
      if (this.exportNum && !pattern.test(this.exportNum)) {
        this.$message.info(this.isPrint ? this.$t('打印条数只能为正整数！') : this.$t('导出条数只能为正整数！'));
        // input 框绑定的内容为空
        this.exportNum = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title_top {
  cursor: pointer;
  margin-top: -8px;
  border-bottom: 1px solid #eee;
  padding: 3px 0;
  padding-bottom: 9px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 23px;
  font-weight: 700;
  font-size: 15px !important;
}
.input_export {
  width: 100px !important;
  margin: 0 5px;
}
.el-radio {
  margin-right: 16px;
  margin-bottom: 16px;
}
</style>
